import { render } from "./ReportsList.vue?vue&type=template&id=20f5fb18&scoped=true"
import script from "./ReportsList.vue?vue&type=script&lang=js"
export * from "./ReportsList.vue?vue&type=script&lang=js"

import "./ReportsList.vue?vue&type=style&index=0&id=20f5fb18&scoped=true&lang=css"

import exportComponent from "/builds/uf-manage/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f5fb18"]])

export default __exports__